import { IconButton } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { UserButton } from 'page/catalog/BoutiqueHeader/UserButton'
import { ComboCartIndicator } from 'page/catalog/ComboCart'
import { ComboCartIndicatorBaga } from 'page/catalog/ComboCart/ComboCartIndicatorBaga'
import { boutiqueQrModal, BoutiqueQrModalStore } from 'page/catalog/store/BoutiqueQrModalStore'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { user } from 'page/catalog/store/UserStore'
import { opt } from 'store/opt'
import { formatDateTimeShort } from 'util/date'
import { space } from 'util/typo'
import css from './RightPane.module.scss'

export const RightPane = observer(() => {
  const { widget_user_id, data, last_time } = user.optional ?? {}
  const disabled = !widget_user_id || !data?.picture

  const onFavorites = useLatestCallback(() => {
    user.it.fav()
  })

  const onQr = useLatestCallback(() => {
    if (widget_user_id)
      boutiqueQrModal.open(new BoutiqueQrModalStore(widget_user_id))
  })

  const onOpenComboCart = useLatestCallback(() => {
    comboCartStore.open = true
  })

  if (!user.present) return <UserButton />

  return (
    <>
      <Space gap={8}>
        <UserButton />
        <Space>
          <IconButton large action={onFavorites} disabled={disabled}>
            <Icon size={16} name="favorite" />
          </IconButton>
          <IconButton large action={onQr} disabled={disabled}>
            <Icon size={16} name="qr_code" />
          </IconButton>
        </Space>
        {opt.baga ? <ComboCartIndicatorBaga onOpen={onOpenComboCart} /> :
          <ComboCartIndicator onOpen={onOpenComboCart} />}
        {last_time && <Space className={css.time}>
          <Typo size={11} line={12} secondary>
            {i18n('LatestGeneration')}
            {space}
            {formatDateTimeShort(last_time)}
          </Typo>
        </Space>}
      </Space>
    </>
  )
})
